/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Type of homepage badge
 */
export enum HomepageBadgeType {
  ULTRA_LIMITED = 'ultra_limited',
  LUMINO = 'lumino',
  LIMITED = 'limited',
  PROMO = 'promo',
  SALE = 'sale',
  BRAND_PREMIERE = 'brand_premiere',
  EXCLUSIVE_DROP = 'exclusive_drop',
  NEW_COLLECTION = 'new_collection',
  CHARITY = 'charity',
  ACCESSORIES = 'accessories',
  INSPIRATIONS = 'inspirations',
  ARTISTS = 'artists',
  COMMUNITY = 'community',
  EPIC_GIFT = 'epic_gift',
  LAST_CHANCE = 'last_chance',
  LEAVING_SOON = 'leaving_soon',
}
